import "./StyledTooltip.scss";

import React from "react";
import type { TooltipProps } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";

const renderTooltip =
  (tooltipText: React.ReactNode | React.ReactNode[], className?: string) =>
  (props: TooltipProps) =>
    (
      <Tooltip {...props} className={`styled-tooltip ${className}`}>
        {tooltipText}
      </Tooltip>
    );

export { renderTooltip };
